/*
 * Decalque em canvas para os painéis frontais/laterais dos módulos
 * auxiliares (ver docs/specs/cma-modulos-auxiliares-3d.md, §6.3) — logo,
 * texto, rótulos de LED e diagramas viram uma textura, em vez de centenas
 * de meshes de letra por módulo.
 *
 * `desenhar` usa a API 2D normal do canvas. Em ambiente de teste
 * `getContext('2d')` devolve `null` (ver CmaAsset3dView.spec.js e o mesmo
 * cuidado em `addGroundLogo`), então aqui devolve-se `null` em vez de uma
 * textura — quem chama decide o que fazer sem mapa (ver `bm2.js`, que só
 * atribui `map` quando a textura existe).
 */
import * as THREE from 'three';

export function criarDecalCanvas(desenhar, larguraPx, alturaPx) {
  const canvas = document.createElement('canvas');
  canvas.width = larguraPx;
  canvas.height = alturaPx;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  desenhar(ctx, larguraPx, alturaPx);

  const textura = new THREE.CanvasTexture(canvas);
  textura.encoding = THREE.sRGBEncoding;
  textura.anisotropy = 8;
  textura.needsUpdate = true;
  return textura;
}

export default criarDecalCanvas;
